import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "g-field__label"
};
const _hoisted_2 = ["for"];
const _hoisted_3 = { class: "g-field__input d-flex flex-column" };
const _hoisted_4 = {
    key: 0,
    class: "g-field__error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['g-field', _ctx.fieldClasses, _ctx.$attrs['field-class']])
    }, [
        (_ctx.hasLabel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.label)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        for: _ctx.identification,
                        class: _normalizeClass(_ctx.fieldLabelClasses)
                    }, _toDisplayString(_ctx.label), 11, _hoisted_2))
                    : _createCommentVNode("", true),
                (_ctx.helpText)
                    ? _withDirectives((_openBlock(), _createBlock(_component_g_icon, {
                        key: 1,
                        src: "/assets/icons/info-square.svg",
                        class: "text-muted"
                    }, null, 512)), [
                        [_directive_tooltip, _ctx.helpText]
                    ])
                    : (_ctx.helpLink)
                        ? (_openBlock(), _createBlock(_component_g_link, {
                            key: 2,
                            target: "modal",
                            src: _ctx.helpLink,
                            class: "text-end"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_icon, {
                                    src: "/assets/icons/info-square.svg",
                                    class: "text-muted"
                                })
                            ]),
                            _: 1
                        }, 8, ["src"]))
                        : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "g-field-input", _normalizeProps(_guardReactiveProps({ identification: _ctx.identification, error: _ctx.error, errorMessage: _ctx.errorMessage, disabled: _ctx.disabled, size: _ctx.size, setFocusClass: _ctx.setFocusClass, removeFocusClass: _ctx.removeFocusClass }))),
            (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true)
        ])
    ], 2));
}
